/** Exact customer/catalog names, grouped by family. Never normalize these strings or infer clinical facts from them. */
export const PROCEDURE_NAMES = {
  'burn-treatment': [
    'Burn Treatment / Dressing',
    'Wound & Soft Tissue: Burn Treatment / Dressing',
    'Burn 2nd degree',
    'Burn 1st degree',
    'Burn 3rd degree',
    'PROD: Burn care, superficial',
    'PROD: Burn care, partial thickness',
  ],
  cerumen: [
    'Impacted Cerumen Removal',
    'Ear Lavage / Cerumen Removal',
    'ENT Procedures: Ear Lavage / Cerumen Removal',
    'Cerumen impaction',
    'Ear irrigation',
    'PROD: Cerumen removal, irrigation',
    'Cerumen (earwax) removal',
  ],
  ekg: [
    'Diagnostic EKG',
    'EKG',
    'Diagnostic Procedures: EKG',
    'Electrocardiogram (EKG) with interpretation',
    'TEST: EKG, complete',
  ],
  'foreign-body': [
    'Foreign Body Removal',
    'Foreign Body Removal (Skin, Ear, Nose, Eye)',
    'Eye Irrigation or Eye Foreign Body Removal',
    'Foreign Body Removal: Foreign Body Removal (Skin, Ear, Nose, Eye)',
    'Foreign Body Removal: Eye Irrigation or Eye Foreign Body Removal',
    'Foreign body removal - ear',
    'Foreign body removal - nose',
    'Foreign body removal - subcutaneous',
    'Nasal foreign body removal',
    'PROD: Remove foreign body, ear',
    'PROD: Remove nasal foreign body',
    'Removal of foreign body, ear',
    'PROD: Remove conjunctival foreign body',
    'Removal of foreign body, superficial (eye)',
    'Removal of foreign body, embedded (eye)',
    'Removal of foreign body, external eye with slit lamp',
    'Removal of foreign body, skin (simple)',
    'Removal of foreign body, skin (complex)',
  ],
  'incision-drainage': [
    'Incision & Drainage of Abscess',
    'Incision and Drainage (I&D) of Abscess',
    'Incision, Drainage & Infection: Incision and Drainage (I&D) of Abscess',
    'Drainage of skin abscess',
    'Drainage of skin adscess',
    'Paronychia drainage',
    'Puncture aspiration of abscess or hematoma',
    'PROD: I&D abscess, simple',
    'Incision and drainage of abscess (simple)',
    'Incision and drainage of abscess (complex)',
  ],
  'injection-infusion': [
    'Therapeutic Injections & IV Infusions',
    'Intramuscular (IM) Medication Injection',
    'IV Push Medication Administration',
    'IV Fluid Administration',
    'Injections & Infusions: Intramuscular (IM) Medication Injection',
    'Injections & Infusions: IV Fluid Administration',
    'Hydrate IV infusion, add-on',
    'Hydration IV infusion, init',
  ],
  'iv-catheter-placement': [
    'Intravenous (IV) Catheter Placement',
    'Injections & Infusions: Intravenous (IV) Catheter Placement',
  ],
  laceration: [
    'Laceration Repair (Wound Closure)',
    'Laceration Repair (Suturing/Stapling)',
    'Wound & Soft Tissue: Laceration Repair (Suturing/Stapling)',
    'Laceration < 2 cm',
    'Laceration repair > 2.5 cm',
    'Repair superficial wound(s)',
    'PROD: Simple laceration repair',
    'Simple repair, scalp/neck/axilla/trunk/genital (≤2.5 cm)',
    'Simple repair, 2.6-7.5 cm',
    'Simple repair, 7.6-12.5 cm',
    'Simple repair, 12.6-20 cm',
    'Simple repair, 20.1-30 cm',
    'Simple repair, 30.1-45 cm',
    'Simple repair, face/ears/eyelids/lips/nose (≤2.5 cm)',
    'Simple repair, face (2.6-5 cm)',
    'Simple repair, face (5.1-7.5 cm)',
    'Simple repair, face (7.6-12.5 cm)',
    'Simple repair, face (12.6-20 cm)',
    'Simple repair, face (20.1-30 cm)',
    'Simple repair, face (30.1-45 cm)',
    'Intermediate repair, trunk (≤2.5 cm)',
    'Intermediate repair, trunk (2.6-7.5 cm)',
    'Intermediate repair, trunk (7.6-12.5 cm)',
    'Intermediate repair, trunk (12.6-20 cm)',
    'Intermediate repair, trunk (20.1-30 cm)',
    'Intermediate repair, trunk (30.1-45 cm)',
    'Intermediate repair, face (≤2.5 cm)',
    'Intermediate repair, face (2.6-5 cm)',
    'Intermediate repair, face (5.1-7.5 cm)',
    'Intermediate repair, face (7.6-12.5 cm)',
    'Intermediate repair, face (12.6-20 cm)',
    'Intermediate repair, face (20.1-30 cm)',
    'Intermediate repair, face (30.1-45 cm)',
    'Complex repair, face (≤2.5 cm)',
    'Complex repair, face (2.6-5 cm)',
    'Complex repair, face (5.1-7.5 cm)',
    'Complex repair, face (7.6-12.5 cm)',
    'Complex repair, face (12.6-20 cm)',
    'Complex repair, face (20.1-30 cm)',
    'Complex repair, face (30.1-45 cm)',
  ],
  'lesion-destruction': ['Wart / Benign Lesion Destruction', 'Wart Treatment (Cryotherapy with Liquid Nitrogen'],
  'nail-trephination': [
    'Nail Trephination (Subungual Hematoma Drainage)',
    'Nail & Digit Procedures: Nail Trephination (Subungual Hematoma Drainage)',
    'Subungual hematoma drainage',
    'PROD: Drain subungual hematoma',
  ],
  'nasal-packing': ['Nasal Packing (Epistaxis Control)', 'ENT Procedures: Nasal Packing (Epistaxis Control)'],
  nebulizer: [
    'Nebulizer Treatment',
    'Nebulizer Treatment (e.g., Albuterol)',
    'Respiratory Procedures: Nebulizer Treatment',
    'Nebulization therapy',
  ],
  'nursemaid-elbow': [
    "Reduction of Nursemaid's Elbow",
    'Reduction of Nursemaid’s Elbow',
    "Orthopedic: Reduction of Nursemaid's Elbow",
    "Nursemaid's elbow reduction",
  ],
  splinting: [
    'Splinting & Strapping',
    'Splint Application / Immobilization',
    'In house made Splinting: Splint Application / Immobilization',
    'In house made Splinting: Thumb Spica',
    'In house made Splinting: Total Knee Orthosis (TKO) Fracture Splint',
    'Nail & Digit Procedures: Finger Splint (Static)',
    'Finger splint',
    'Long arm splint 11+',
    'Long arm splint Peds',
    'Short arm splint 11+',
    'Short arm splint Peds',
    'Long leg splint 11+',
    'Long leg splint Peds',
    'Short leg splint 11+',
    'Short leg splint Peds',
  ],
  'urinary-catheterization': ['Urinary Catheterization', 'Urine catheter'],
} as const satisfies Record<string, readonly string[]>;
